<template>

  <!-- <main class="hover-overlay" @mouseover="getCoords"> -->
    <div
      :class="hoverClass()"
      :style="{
        'top': calcEdge('top'),
        'left': calcEdge('left')
      }"
    >
      <h4 v-if="temp.type !== 'mini'">{{temp.title}}</h4>
      <h4 v-if="temp.type == 'mini'" v-html="temp.content[0].sub"></h4>
      <div class="hover-body" v-if="temp.type != 'media'">
        <div class="hover-sec" v-for="sec in temp.content">
          <h4 style="width:100%;text-align:left;" v-html="sec.sub"></h4>
          <p v-html="sec.body"></p>
        </div>
      </div>
      <youtube style="margin-bottom:20px;" :player-width="400" :player-vars="{autoplay: 1}" v-if="temp.type == 'vid'" :video-id="videoId"></youtube>
      <div class="hover-body" v-if="temp.type == 'media'">
        <img :src="temp.content[0].img" />
        <p v-html="temp.content[0].body"></p>
      </div>
    </div>
  <!-- </main> -->

</template>

<script>

  import { getIdFromURL, getTimeFromURL } from 'vue-youtube-embed';

  export default {

    data(){
      return {
        coords: {},
        videoId: '',
        startTime: null
      }
    },

    computed: {
      temp(){
        return this.$store.state.hover.temp;
      }
    },

    methods: {

      calcEdge(edge){
        const coords = {x: this.temp.x, y: this.temp.y};
        const screenDims = {w: window.innerWidth, h: window.innerHeight}
        const d = screenDims[edge == 'top' ? 'h' : 'w'];
        const c = coords[edge == 'top' ? 'y' : 'x'];
        const center = {min: d * .25, max: d - (d*.25)};
        let pos;
        if (this.temp.type == 'mini') {
          return `${
            d == 'h'
              ? c + 20
              : c + 10
          }px`
        }
      },

      hoverClass(){
        if (this.temp.type === 'vid') {
          return 'hover hover-vid';
        } else if (this.temp.type == 'media') {
          return 'hover hover-media'
        } else {
          return `hover${this.temp.type == 'full' ? '' : ' hover-mini'}`;
        }
      }

    },

    mounted(){
      if (this.temp.type == 'vid') {
        this.videoId = this.$youtube.getIdFromURL(this.temp.src);
        this.startTime = this.$youtube.getTimeFromURL(this.temp.src);
      }
    },

  }

</script>

<style>

.hover {
  width: 300px;
  max-height: 500px;
  position: absolute;
  background: #404342;
  border-radius: 5px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  font-family: 'Comfortaa', sans-serif;
  animation: fadequick 1s forwards;
  opacity: 0;
  border: 1px solid #dce1ec;
}

@keyframes fadequick {
  0% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.hover-body {
  width: 92.5%;
  height: auto;
  overflow: scroll;
  margin: 2px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.hover h4 {
  width: 100%;
  text-align: left;
  color: lightblue;
  margin: 8px;
  text-align: center;
}

.hover-sec p {
  width: 95%;
  display: flex;
  font-weight: 400;
  font-family: 'Roboto', sans-serif;
  margin: 0px;
  justify-content: center;
  margin-top: 2px;
}

.hover-sec p p {
  font-size: .85em;
}

.hover h3 {
  width: 93%;
  color: rgb(0, 153, 191);
  border-bottom: 2px solid rgb(0, 153, 191);
}

.hover-mini {
  /* min-width: 150px; */
  height: 40px;
  justify-content: center;
  align-items: center;
  padding-top: .5%;
}

.hover-sec h5 {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 4px;
  /* color: lightblue; */
}

.hover-vid {
  min-width: 500px;
  height: auto;
}

.hover-sec {
  padding-bottom: 9px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.hover-media {
  min-width: 400px;
  height: auto;
}

.hover-media img {
  height: 300px;
  width: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/util/Hover.vue